export enum CommentEntityTypes {
  NON_CONFORMANCE = 1,
  SUBTASK = 2,
  ORDER = 3,
}
